import React from "react";

import { templates } from "@reactivated";

import { LocatorQuickSearchSSR } from "../apps/retail-locator/LocatorQuickSearchSSR";

export const Template = (
    props: templates.LocatorQuickSearchTemplate,
): React.JSX.Element => {
    return <LocatorQuickSearchSSR {...props} />;
};
